import { render, staticRenderFns } from "./VolumeDetail.vue?vue&type=template&id=4080dd9e&"
import script from "./VolumeDetail.vue?vue&type=script&lang=js&"
export * from "./VolumeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports